var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5V0.5ZM26 3.5C26.8284 3.5 27.5 2.82843 27.5 2C27.5 1.17157 26.8284 0.5 26 0.5V3.5ZM2 8.97059C1.17157 8.97059 0.5 9.64216 0.5 10.4706C0.5 11.299 1.17157 11.9706 2 11.9706V8.97059ZM26 11.9706C26.8284 11.9706 27.5 11.299 27.5 10.4706C27.5 9.64216 26.8284 8.97059 26 8.97059V11.9706ZM2 17.4412C1.17157 17.4412 0.5 18.1128 0.5 18.9412C0.5 19.7696 1.17157 20.4412 2 20.4412V17.4412ZM26 20.4412C26.8284 20.4412 27.5 19.7696 27.5 18.9412C27.5 18.1128 26.8284 17.4412 26 17.4412V20.4412ZM2 3.5H26V0.5H2V3.5ZM2 11.9706H26V8.97059H2V11.9706ZM2 20.4412H26V17.4412H2V20.4412Z",
    fill: "#7B7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.acb7ddf2064763f86acb4a1f1db68c47.svg";
export { ForwardRef as ReactComponent };